import React, { Component } from 'react';
import {
  Alert,
  Dimensions,
  Image,
  PixelRatio,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';
import { FontAwesomeIcon, KeyboardAwareScrollView } from '../modules';
import { signOut } from '../actions/user';
import UserUtils from '../utils/UserUtils';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class ProfileScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {routes, params} = navigation.state;
    return {
      tabBarIcon: ({focused, tintColor}) => {
        return (
          <FontAwesomeIcon
            name='user'
            size={28}
            color={tintColor}/>
        );
      },
      tabBarVisible: !routes || routes.length <= 1,

      title: 'Trang cá nhân',
      headerBackTitle: null,
    };
  };

  constructor (props) {
    super(props);

    const {user} = this.props;
    const {info} = user;
    this.state = {
      user: user,
      email: _.isEmpty(info.email) ? '' : info.email,
      phone: _.isEmpty(info.phone) ? '' : info.phone,
      name: _.isEmpty(info.name) ? '' : info.name,
      promoCode: info.promoCode,
    };
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
    const {user} = nextProps;
    if (this.state.user != user) {
      const {info} = user;
      this.setState({
        user: user,
        email: info.email,
        phone: info.phone,
        name: info.name,
        promoCode: info.promoCode,
      });
    }
  }

  _updateInputValue (name, value) {
    this.setState({
      [name]: value,
    });
  }

  _focusTextInput (name) {
    const textInput = this.refs[name];
    if (textInput) {
      textInput.focus();
    }
  }

  _logout = () => {
    const message = 'Bạn có chắc là muốn đăng xuất khỏi tài khoản hiện tại';
    if (Platform.OS === 'web') {
      const result = window.confirm(message);
      if (result) {
        this._doLogout();
      }
    } else {
      Alert.alert(
        global.__APP_NAME__,
        message,
        [
          {text: 'Bỏ qua', style: 'cancel'},
          {text: 'Đăng xuất', onPress: () => this._doLogout()},
        ],
      );
    }
  };

  _doLogout () {
    const {credential, fcmToken} = this.props;
    UserUtils.signOut(credential, fcmToken);

    const {signOut} = this.props;
    signOut();
  }

  _updatePromoCode = () => {
    if (Platform.OS === 'web') {
      this.props.history.push('/promo-code');
    } else {
      this.props.navigation.navigate('UpdatePromoCode', {});
    }
  };

  _updatePayment = () => {
    if (Platform.OS === 'web') {
      this.props.history.push('/payment');
    } else {
      this.props.navigation.navigate('Payment', {});
    }
  };

  _updatePassword = () => {
    if (Platform.OS === 'web') {
      this.props.history.push('/password');
    } else {
      this.props.navigation.navigate('UpdatePassword', {});
    }
  };

  render () {
    const {user} = this.props;
    const isAdmin = UserUtils.isAdmin(user);
    const isSalesman = UserUtils.isSalesman(user);
    const isSeller = UserUtils.isSeller(user);
    const {email, phone, name, promoCode} = this.state;
    return (
      <View
        style={styles.container}>
        <KeyboardAwareScrollView
          automaticallyAdjustContentInsets={false}
          keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
          keyboardShouldPersistTaps='always'
          containerContentStyle={styles.contentContainer}
          style={styles.content}>

          <Text
            style={[
              styles.inputTitleText, {
                marginTop: 24,
              }]}>
            Địa chỉ email
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='emailTextInput'
              value={email}
              placeholder='Địa chỉ email'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              keyboardType='email-address'
              autoCapitalize='none'
              returnKeyType='next'
              editable={false}
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('email', text)}
              onSubmitEditing={() => this._focusTextInput('phoneTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Số điện thoại
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='phoneTextInput'
              value={phone}
              placeholder='Số điện thoại'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              keyboardType='numeric'
              autoCapitalize='none'
              returnKeyType='next'
              editable={false}
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('phone', text)}
              onSubmitEditing={() => this._focusTextInput('nameTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Họ và tên
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='nameTextInput'
              value={name}
              placeholder='Họ và tên'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              autoCapitalize='words'
              returnKeyType='next'
              editable={false}
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('name', text)}
              onSubmitEditing={() => this._focusTextInput(
                'promoCodeTextInput')}/>
          </View>

          {isSeller && <Text
            style={styles.inputTitleText}>
            Mã giới thiệu
          </Text>}
          {isSeller && <View
            style={styles.input}>
            <TextInput
              ref='promoCodeTextInput'
              value={promoCode}
              placeholder='Mã giới thiệu'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              autoCapitalize='characters'
              returnKeyType='done'
              editable={false}
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('promoCode', text)}
              onSubmitEditing={() => this._focusTextInput(
                'passwordTextInput')}/>
          </View>}

          {isSeller && <TouchableOpacity
            activeOpacity={0.75}
            style={[
              styles.submit, {
                marginTop: 24,
              }]}
            onPress={this._updatePromoCode}>
            <Image
              source={require('../img/btn.png')}
              style={styles.submitImage}/>
            <Text
              style={styles.submitText}>
              ĐỔI MÃ GIỚI THIỆU
            </Text>
          </TouchableOpacity>}

          {isSeller && <TouchableOpacity
            activeOpacity={0.75}
            style={styles.submit}
            onPress={this._updatePayment}>
            <Image
              source={require('../img/btn4.png')}
              style={styles.submitImage}/>
            <Text
              style={styles.submitText}>
              THÔNG TIN THANH TOÁN
            </Text>
          </TouchableOpacity>}

          <TouchableOpacity
            activeOpacity={0.75}
            style={styles.submit}
            onPress={this._updatePassword}>
            <Image
              source={require('../img/btn2.png')}
              style={styles.submitImage}/>
            <Text
              style={styles.submitText}>
              ĐỔI MẬT KHẨU
            </Text>
          </TouchableOpacity>

        </KeyboardAwareScrollView>

        <View
          style={styles.logoutDivider}/>
        <TouchableOpacity
          activeOpacity={0.75}
          style={styles.logout}
          onPress={this._logout}>
          <Text
            style={styles.logoutText}>
            Đăng xuất
          </Text>
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {},

  inputTitleText: {
    width: contentWidth,
    marginTop: 16,
    alignSelf: 'center',
    color: '#000000',
    fontSize: 16,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  input: {
    width: contentWidth,
    height: 44,
    marginTop: 5,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  submit: {
    width: contentWidth,
    height: 56,
    marginTop: 12,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  submitImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  submitText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  submitting: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  submittingIndicator: {},

  logoutDivider: {
    marginLeft: 12,
    marginRight: 12,
    height: 1 / PixelRatio.get(),
    backgroundColor: '#d7cba9',
  },
  logout: {
    height: 56,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoutText: {
    color: '#ff0000',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
  },
});

const mapStateToProps = (state) => {
  return {
    credential: state.user.credential,
    user: state.user,
    fcmToken: state.device.fcmToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileScreen);



// WEBPACK FOOTER //
// ./src/profile/ProfileScreen.js